<div class="d-flex justify-content-between">
    <p *ngIf="title.length > 0" class="fw-semibold text-secondary">{{ title }}</p>
    <div>
        <ng-container *ngFor="let method of methods">
            <img (click)="genericTitleMethod(method.name)" class="avs-icon-add mb-3" [src]="method.src"
                alt="Wechselbild erstellen"></ng-container>
    </div>
</div>
<div class="row avs-project-images-container justify-content-center">
    <ng-container *ngFor="let image of images">
        <div (click)="onImageClicked(image)" class="mb-3 avs-project-images">
            <div class="d-flex justify-content-center ">
                <div class="position-relative"
                    [ngClass]="(image.stellcode === preSelectedImage?.stellcode || image.stellcode === controlsStellcode )? 'border-danger border-5 border' : ''">
                    <img [src]="getImagePath(image)" alt="Bilderkatalog">
                    <img *ngIf="image.isAnimated" src="assets/icons/shuffle.svg" alt="animatedImage"
                        class="position-absolute bg-white rounded-5 p-1 " style="top: 1px; right: 2px; height: 20px">
                    <img *ngIf="image.stellcodeStatusOk === true" src="assets/icons/status-ok-bold.svg" alt="status-ok"
                        class="position-absolute bg-white rounded-5 p-1" style="top: 1px; left: 2px; height: 26px">
                    <img *ngIf="image.stellcodeStatusOk === false" src="assets/icons/status-not-ok-bold.svg" alt="status-not-ok"
                        class="position-absolute bg-white rounded-5 p-1" style="top: 1px; left: 2px; height: 26px">
                </div>
            </div>
            <div class="small text-center">Stellcode: {{image.stellcode}}</div>
            <div *ngIf="image.statusLabel" class="small text-center text-secondary">{{image.statusLabel}}</div>
        </div>
    </ng-container>
</div>
